<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs12>
          <h1>Create Student</h1>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>

      <v-layout style="margin-top:50px;">
        <v-flex xs6>
          <v-form ref="createStudentForm" v-model="valid" class="compact-form">
            <v-layout column>
              <v-flex>
                <v-text-field v-model="student.nameFirst" :rules="rules" label="First Name"
                  append-outer-icon="priority_high">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.nameLast" :rules="rules" label="Last Name"
                  append-outer-icon="priority_high">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.address" label="Address"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.city" label="City"></v-text-field>
              </v-flex>
              <v-flex>
                <v-select v-model="student.state" :items="states" label="State"></v-select>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.zip" label="Zipcode"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.phone" label="Phone" mask="(###)###-####" :return-masked-value="true">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.cellPhone" label="Cell Phone" mask="(###)###-####" :return-masked-value="true">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.emergencyPhone" label="Emergency Phone" mask="(###)###-####" :return-masked-value="true">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.email" label="Email"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.dob" label="Date of Birth" mask="##/##/####" :return-masked-value="true">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-select v-model="student.gender" :items="genders" :rules="rules" label="Gender"
                  append-outer-icon="priority_high"></v-select>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.startDate" label="Start Date" mask="##/##/####"
                  :return-masked-value="true">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-select v-model="student.rank" :items="ranks" label="Rank">
                </v-select>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.testNumber" label="Test Number">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.beltSize" label="Belt Size">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.ITFnumber" label="ITF Number">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="student.lastTest" label="Last Test" mask="##/##/####"
                  :return-masked-value="true"></v-text-field>
              </v-flex>
              <v-flex>
                <v-textarea v-model="student.referral" label="How did you find C.S. Kim Karate Fort Wayne?">
                </v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-btn color="success" @click="createStudent" :disabled="!valid">Save</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
        <v-flex offset-xs2 xs2 style="text-align:center;">
          <v-chip disabled>
            <v-icon>priority_high</v-icon> <strong>Indicates a required field.</strong>
          </v-chip>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';

  export default {
    data() {
      return {
        valid: true,
        rules: [v => !!v || "Required"],
        student: {
          nameFirst: "",
          nameLast: "",
          address: "",
          city: "",
          state: "",
          zip: "",
          phone: "",
          cellPhone: "",
          emergencyPhone: "",
          email: "",
          dob: "",
          gender: "",
          startDate: "",
          rank: "",
          testNumber: "",
          beltSize: "",
          ITFnumber: "",
          referral: "",
          lastTest: ""
        }
      };
    },
    computed: {
      ...mapGetters({
        states: "getStates",
        genders: "getGenders",
        ranks: "getRanks"
      })
    },
    methods: {
      createStudent() {
        this.$store.dispatch("createStudent", this.student).then(() => {
          this.$router.push({
            name: "StudentsSummary"
          });
        });
      }
    }
  }
</script>

<style>

</style>